// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/insights.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { DateRange, Resolution, TimeSeriesPoint } from "./usage_pb.js";
import { SupportedModel } from "./agent_pb.js";

/**
 * CoAuthorTool identifies the AI tool that co-authored a commit.
 * UNSPECIFIED (0) is the proto default and must not appear in reported data.
 * Use HUMAN for commits with no AI co-author.
 *
 * @generated from enum gitpod.v1.CoAuthorTool
 */
export enum CoAuthorTool {
  /**
   * @generated from enum value: CO_AUTHOR_TOOL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Commit has no Co-authored-by trailer at all (solo commit).
   *
   * @generated from enum value: CO_AUTHOR_TOOL_NO_COAUTHOR = 1;
   */
  NO_COAUTHOR = 1,

  /**
   * Commit has a Co-authored-by trailer, but the co-author is human.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_HUMAN_COAUTHOR = 2;
   */
  HUMAN_COAUTHOR = 2,

  /**
   * Ona agent.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_ONA = 3;
   */
  ONA = 3,

  /**
   * GitHub Copilot.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_GITHUB_COPILOT = 4;
   */
  GITHUB_COPILOT = 4,

  /**
   * Cursor.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_CURSOR = 5;
   */
  CURSOR = 5,

  /**
   * An AI tool not in the known list.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_OTHER = 6;
   */
  OTHER = 6,

  /**
   * Claude (Anthropic).
   *
   * @generated from enum value: CO_AUTHOR_TOOL_CLAUDE = 7;
   */
  CLAUDE = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(CoAuthorTool)
proto3.util.setEnumType(CoAuthorTool, "gitpod.v1.CoAuthorTool", [
  { no: 0, name: "CO_AUTHOR_TOOL_UNSPECIFIED" },
  { no: 1, name: "CO_AUTHOR_TOOL_NO_COAUTHOR" },
  { no: 2, name: "CO_AUTHOR_TOOL_HUMAN_COAUTHOR" },
  { no: 3, name: "CO_AUTHOR_TOOL_ONA" },
  { no: 4, name: "CO_AUTHOR_TOOL_GITHUB_COPILOT" },
  { no: 5, name: "CO_AUTHOR_TOOL_CURSOR" },
  { no: 6, name: "CO_AUTHOR_TOOL_OTHER" },
  { no: 7, name: "CO_AUTHOR_TOOL_CLAUDE" },
]);

/**
 * ScmProvider identifies the SCM platform a pull request was fetched from.
 *
 * @generated from enum gitpod.v1.ScmProvider
 */
export enum ScmProvider {
  /**
   * @generated from enum value: SCM_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * GitHub.
   *
   * @generated from enum value: SCM_PROVIDER_GITHUB = 1;
   */
  GITHUB = 1,

  /**
   * GitLab.
   *
   * @generated from enum value: SCM_PROVIDER_GITLAB = 2;
   */
  GITLAB = 2,

  /**
   * Bitbucket.
   *
   * @generated from enum value: SCM_PROVIDER_BITBUCKET = 3;
   */
  BITBUCKET = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ScmProvider)
proto3.util.setEnumType(ScmProvider, "gitpod.v1.ScmProvider", [
  { no: 0, name: "SCM_PROVIDER_UNSPECIFIED" },
  { no: 1, name: "SCM_PROVIDER_GITHUB" },
  { no: 2, name: "SCM_PROVIDER_GITLAB" },
  { no: 3, name: "SCM_PROVIDER_BITBUCKET" },
]);

/**
 * CommitCoAuthorStat represents co-author data for a single commit.
 *
 * @generated from message gitpod.v1.CommitCoAuthorStat
 */
export class CommitCoAuthorStat extends Message<CommitCoAuthorStat> {
  /**
   * SHA of the commit. Used with project_id as the idempotency key.
   *
   * @generated from field: string commit_hash = 1;
   */
  commitHash = "";

  /**
   * Author date of the commit.
   *
   * @generated from field: google.protobuf.Timestamp commit_date = 2;
   */
  commitDate?: Timestamp;

  /**
   * Which tool co-authored this commit, NO_COAUTHOR for solo commits,
   * or HUMAN_COAUTHOR for human pair-programming.
   * UNSPECIFIED is rejected — callers must always set a concrete value.
   *
   * @generated from field: gitpod.v1.CoAuthorTool tool = 3;
   */
  tool = CoAuthorTool.UNSPECIFIED;

  /**
   * Lines added in this commit.
   *
   * @generated from field: int64 lines_added = 4;
   */
  linesAdded = protoInt64.zero;

  /**
   * Lines removed in this commit.
   *
   * @generated from field: int64 lines_removed = 5;
   */
  linesRemoved = protoInt64.zero;

  /**
   * One-way hash of the author email. Enables distinct author counts
   * without storing PII.
   *
   * @generated from field: string author_hash = 6;
   */
  authorHash = "";

  /**
   * Raw co-author email address from the Co-authored-by trailer.
   * Empty when there is no co-author trailer. Stored verbatim so the
   * backend can reclassify historical data when new AI tools are added.
   *
   * @generated from field: string raw_coauthor = 7;
   */
  rawCoauthor = "";

  constructor(data?: PartialMessage<CommitCoAuthorStat>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CommitCoAuthorStat";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "commit_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "commit_date", kind: "message", T: Timestamp },
    { no: 3, name: "tool", kind: "enum", T: proto3.getEnumType(CoAuthorTool) },
    { no: 4, name: "lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "author_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "raw_coauthor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CommitCoAuthorStat {
    return new CommitCoAuthorStat().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CommitCoAuthorStat {
    return new CommitCoAuthorStat().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CommitCoAuthorStat {
    return new CommitCoAuthorStat().fromJsonString(jsonString, options);
  }

  static equals(a: CommitCoAuthorStat | PlainMessage<CommitCoAuthorStat> | undefined, b: CommitCoAuthorStat | PlainMessage<CommitCoAuthorStat> | undefined): boolean {
    return proto3.util.equals(CommitCoAuthorStat, a, b);
  }
}

/**
 * ReportCoAuthorStatsRequest is sent by the CLI to push analysis results.
 *
 * @generated from message gitpod.v1.ReportCoAuthorStatsRequest
 */
export class ReportCoAuthorStatsRequest extends Message<ReportCoAuthorStatsRequest> {
  /**
   * Project that was analyzed.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Per-commit co-author stats to upsert.
   *
   * @generated from field: repeated gitpod.v1.CommitCoAuthorStat stats = 2;
   */
  stats: CommitCoAuthorStat[] = [];

  constructor(data?: PartialMessage<ReportCoAuthorStatsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportCoAuthorStatsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stats", kind: "message", T: CommitCoAuthorStat, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportCoAuthorStatsRequest {
    return new ReportCoAuthorStatsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportCoAuthorStatsRequest {
    return new ReportCoAuthorStatsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportCoAuthorStatsRequest {
    return new ReportCoAuthorStatsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReportCoAuthorStatsRequest | PlainMessage<ReportCoAuthorStatsRequest> | undefined, b: ReportCoAuthorStatsRequest | PlainMessage<ReportCoAuthorStatsRequest> | undefined): boolean {
    return proto3.util.equals(ReportCoAuthorStatsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ReportCoAuthorStatsResponse
 */
export class ReportCoAuthorStatsResponse extends Message<ReportCoAuthorStatsResponse> {
  /**
   * Number of rows inserted (new commits).
   *
   * @generated from field: int64 inserted_count = 1;
   */
  insertedCount = protoInt64.zero;

  /**
   * Number of rows updated (re-reported commits).
   *
   * @generated from field: int64 updated_count = 2;
   */
  updatedCount = protoInt64.zero;

  constructor(data?: PartialMessage<ReportCoAuthorStatsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportCoAuthorStatsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inserted_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "updated_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportCoAuthorStatsResponse {
    return new ReportCoAuthorStatsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportCoAuthorStatsResponse {
    return new ReportCoAuthorStatsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportCoAuthorStatsResponse {
    return new ReportCoAuthorStatsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReportCoAuthorStatsResponse | PlainMessage<ReportCoAuthorStatsResponse> | undefined, b: ReportCoAuthorStatsResponse | PlainMessage<ReportCoAuthorStatsResponse> | undefined): boolean {
    return proto3.util.equals(ReportCoAuthorStatsResponse, a, b);
  }
}

/**
 * GetCoAuthorStatsRequest is used by the dashboard to read aggregated stats.
 * When project_id is set, returns stats for that project only.
 * When project_id is empty, aggregates across all projects in the org.
 *
 * @generated from message gitpod.v1.GetCoAuthorStatsRequest
 */
export class GetCoAuthorStatsRequest extends Message<GetCoAuthorStatsRequest> {
  /**
   * Optional. When set, scopes stats to this project only.
   * When empty, aggregates across all projects in the org.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Date range to query within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * Time resolution for the time series. Defaults to WEEKLY if unspecified.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution = Resolution.UNSPECIFIED;

  /**
   * Organization to query stats for.
   *
   * @generated from field: string organization_id = 4;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetCoAuthorStatsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCoAuthorStatsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "resolution", kind: "enum", T: proto3.getEnumType(Resolution) },
    { no: 4, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCoAuthorStatsRequest {
    return new GetCoAuthorStatsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCoAuthorStatsRequest {
    return new GetCoAuthorStatsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCoAuthorStatsRequest {
    return new GetCoAuthorStatsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCoAuthorStatsRequest | PlainMessage<GetCoAuthorStatsRequest> | undefined, b: GetCoAuthorStatsRequest | PlainMessage<GetCoAuthorStatsRequest> | undefined): boolean {
    return proto3.util.equals(GetCoAuthorStatsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCoAuthorStatsResponse
 */
export class GetCoAuthorStatsResponse extends Message<GetCoAuthorStatsResponse> {
  /**
   * Summary totals for the requested date range.
   *
   * @generated from field: gitpod.v1.CoAuthorSummary summary = 1;
   */
  summary?: CoAuthorSummary;

  /**
   * Time series of contribution stats, bucketed by the requested resolution.
   *
   * @generated from field: repeated gitpod.v1.CoAuthorTimeBucket time_series = 2;
   */
  timeSeries: CoAuthorTimeBucket[] = [];

  constructor(data?: PartialMessage<GetCoAuthorStatsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCoAuthorStatsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "summary", kind: "message", T: CoAuthorSummary },
    { no: 2, name: "time_series", kind: "message", T: CoAuthorTimeBucket, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCoAuthorStatsResponse {
    return new GetCoAuthorStatsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCoAuthorStatsResponse {
    return new GetCoAuthorStatsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCoAuthorStatsResponse {
    return new GetCoAuthorStatsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCoAuthorStatsResponse | PlainMessage<GetCoAuthorStatsResponse> | undefined, b: GetCoAuthorStatsResponse | PlainMessage<GetCoAuthorStatsResponse> | undefined): boolean {
    return proto3.util.equals(GetCoAuthorStatsResponse, a, b);
  }
}

/**
 * CoAuthorSummary contains aggregate totals for a date range.
 *
 * @generated from message gitpod.v1.CoAuthorSummary
 */
export class CoAuthorSummary extends Message<CoAuthorSummary> {
  /**
   * Total number of commits in the date range.
   *
   * @generated from field: int64 total_commits = 1;
   */
  totalCommits = protoInt64.zero;

  /**
   * Total lines added across all commits.
   *
   * @generated from field: int64 total_lines_added = 2;
   */
  totalLinesAdded = protoInt64.zero;

  /**
   * Total lines removed across all commits.
   *
   * @generated from field: int64 total_lines_removed = 3;
   */
  totalLinesRemoved = protoInt64.zero;

  /**
   * Number of distinct authors (by author_hash).
   *
   * @generated from field: int64 distinct_authors = 4;
   */
  distinctAuthors = protoInt64.zero;

  /**
   * Per-tool breakdown of contribution stats.
   *
   * @generated from field: repeated gitpod.v1.ToolBreakdown by_tool = 5;
   */
  byTool: ToolBreakdown[] = [];

  /**
   * Fractional change in total_commits compared to the previous period of equal
   * length. Computed as (current - previous) / previous. Zero when there is no
   * previous data.
   *
   * @generated from field: double total_commits_trend = 6;
   */
  totalCommitsTrend = 0;

  /**
   * Fractional change in total_lines_added compared to the previous period.
   *
   * @generated from field: double total_lines_added_trend = 7;
   */
  totalLinesAddedTrend = 0;

  /**
   * Fractional change in total_lines_removed compared to the previous period.
   *
   * @generated from field: double total_lines_removed_trend = 8;
   */
  totalLinesRemovedTrend = 0;

  /**
   * Fractional change in distinct_authors compared to the previous period.
   *
   * @generated from field: double distinct_authors_trend = 9;
   */
  distinctAuthorsTrend = 0;

  constructor(data?: PartialMessage<CoAuthorSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CoAuthorSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_commits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "total_lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "total_lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "distinct_authors", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "by_tool", kind: "message", T: ToolBreakdown, repeated: true },
    { no: 6, name: "total_commits_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "total_lines_added_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "total_lines_removed_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "distinct_authors_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CoAuthorSummary {
    return new CoAuthorSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CoAuthorSummary {
    return new CoAuthorSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CoAuthorSummary {
    return new CoAuthorSummary().fromJsonString(jsonString, options);
  }

  static equals(a: CoAuthorSummary | PlainMessage<CoAuthorSummary> | undefined, b: CoAuthorSummary | PlainMessage<CoAuthorSummary> | undefined): boolean {
    return proto3.util.equals(CoAuthorSummary, a, b);
  }
}

/**
 * ToolBreakdown contains stats for a single AI tool (or human).
 *
 * @generated from message gitpod.v1.ToolBreakdown
 */
export class ToolBreakdown extends Message<ToolBreakdown> {
  /**
   * The tool these stats are for.
   *
   * @generated from field: gitpod.v1.CoAuthorTool tool = 1;
   */
  tool = CoAuthorTool.UNSPECIFIED;

  /**
   * Number of commits attributed to this tool.
   *
   * @generated from field: int64 commits = 2;
   */
  commits = protoInt64.zero;

  /**
   * Lines added by this tool.
   *
   * @generated from field: int64 lines_added = 3;
   */
  linesAdded = protoInt64.zero;

  /**
   * Lines removed by this tool.
   *
   * @generated from field: int64 lines_removed = 4;
   */
  linesRemoved = protoInt64.zero;

  /**
   * Distinct authors who used this tool.
   *
   * @generated from field: int64 distinct_authors = 5;
   */
  distinctAuthors = protoInt64.zero;

  constructor(data?: PartialMessage<ToolBreakdown>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ToolBreakdown";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tool", kind: "enum", T: proto3.getEnumType(CoAuthorTool) },
    { no: 2, name: "commits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "distinct_authors", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ToolBreakdown {
    return new ToolBreakdown().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ToolBreakdown {
    return new ToolBreakdown().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ToolBreakdown {
    return new ToolBreakdown().fromJsonString(jsonString, options);
  }

  static equals(a: ToolBreakdown | PlainMessage<ToolBreakdown> | undefined, b: ToolBreakdown | PlainMessage<ToolBreakdown> | undefined): boolean {
    return proto3.util.equals(ToolBreakdown, a, b);
  }
}

/**
 * CoAuthorTimeBucket contains stats for a single time period.
 *
 * @generated from message gitpod.v1.CoAuthorTimeBucket
 */
export class CoAuthorTimeBucket extends Message<CoAuthorTimeBucket> {
  /**
   * Start of this time bucket.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * Per-tool breakdown for this bucket.
   *
   * @generated from field: repeated gitpod.v1.ToolBreakdown by_tool = 2;
   */
  byTool: ToolBreakdown[] = [];

  /**
   * Total lines added in this bucket (across all tools).
   *
   * @generated from field: int64 total_lines_added = 3;
   */
  totalLinesAdded = protoInt64.zero;

  /**
   * Total lines removed in this bucket (across all tools).
   *
   * @generated from field: int64 total_lines_removed = 4;
   */
  totalLinesRemoved = protoInt64.zero;

  /**
   * Ratio of AI-assisted lines added to total lines added (0.0–1.0).
   *
   * @generated from field: double ai_ratio = 5;
   */
  aiRatio = 0;

  /**
   * Total number of commits in this bucket (across all tools).
   *
   * @generated from field: int64 total_commits = 6;
   */
  totalCommits = protoInt64.zero;

  /**
   * Number of distinct authors (by author_hash) in this bucket.
   *
   * @generated from field: int64 distinct_authors = 7;
   */
  distinctAuthors = protoInt64.zero;

  constructor(data?: PartialMessage<CoAuthorTimeBucket>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CoAuthorTimeBucket";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "by_tool", kind: "message", T: ToolBreakdown, repeated: true },
    { no: 3, name: "total_lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "total_lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "ai_ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "total_commits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "distinct_authors", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CoAuthorTimeBucket {
    return new CoAuthorTimeBucket().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CoAuthorTimeBucket {
    return new CoAuthorTimeBucket().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CoAuthorTimeBucket {
    return new CoAuthorTimeBucket().fromJsonString(jsonString, options);
  }

  static equals(a: CoAuthorTimeBucket | PlainMessage<CoAuthorTimeBucket> | undefined, b: CoAuthorTimeBucket | PlainMessage<CoAuthorTimeBucket> | undefined): boolean {
    return proto3.util.equals(CoAuthorTimeBucket, a, b);
  }
}

/**
 * EnableProjectInsightsRequest enables co-author insights for a project.
 *
 * @generated from message gitpod.v1.EnableProjectInsightsRequest
 */
export class EnableProjectInsightsRequest extends Message<EnableProjectInsightsRequest> {
  /**
   * Project to enable insights for.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  constructor(data?: PartialMessage<EnableProjectInsightsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EnableProjectInsightsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnableProjectInsightsRequest {
    return new EnableProjectInsightsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnableProjectInsightsRequest {
    return new EnableProjectInsightsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnableProjectInsightsRequest {
    return new EnableProjectInsightsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EnableProjectInsightsRequest | PlainMessage<EnableProjectInsightsRequest> | undefined, b: EnableProjectInsightsRequest | PlainMessage<EnableProjectInsightsRequest> | undefined): boolean {
    return proto3.util.equals(EnableProjectInsightsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EnableProjectInsightsResponse
 */
export class EnableProjectInsightsResponse extends Message<EnableProjectInsightsResponse> {
  constructor(data?: PartialMessage<EnableProjectInsightsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EnableProjectInsightsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnableProjectInsightsResponse {
    return new EnableProjectInsightsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnableProjectInsightsResponse {
    return new EnableProjectInsightsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnableProjectInsightsResponse {
    return new EnableProjectInsightsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EnableProjectInsightsResponse | PlainMessage<EnableProjectInsightsResponse> | undefined, b: EnableProjectInsightsResponse | PlainMessage<EnableProjectInsightsResponse> | undefined): boolean {
    return proto3.util.equals(EnableProjectInsightsResponse, a, b);
  }
}

/**
 * DisableProjectInsightsRequest disables co-author insights for a project.
 *
 * @generated from message gitpod.v1.DisableProjectInsightsRequest
 */
export class DisableProjectInsightsRequest extends Message<DisableProjectInsightsRequest> {
  /**
   * Project to disable insights for.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  constructor(data?: PartialMessage<DisableProjectInsightsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DisableProjectInsightsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DisableProjectInsightsRequest {
    return new DisableProjectInsightsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DisableProjectInsightsRequest {
    return new DisableProjectInsightsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DisableProjectInsightsRequest {
    return new DisableProjectInsightsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DisableProjectInsightsRequest | PlainMessage<DisableProjectInsightsRequest> | undefined, b: DisableProjectInsightsRequest | PlainMessage<DisableProjectInsightsRequest> | undefined): boolean {
    return proto3.util.equals(DisableProjectInsightsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DisableProjectInsightsResponse
 */
export class DisableProjectInsightsResponse extends Message<DisableProjectInsightsResponse> {
  constructor(data?: PartialMessage<DisableProjectInsightsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DisableProjectInsightsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DisableProjectInsightsResponse {
    return new DisableProjectInsightsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DisableProjectInsightsResponse {
    return new DisableProjectInsightsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DisableProjectInsightsResponse {
    return new DisableProjectInsightsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DisableProjectInsightsResponse | PlainMessage<DisableProjectInsightsResponse> | undefined, b: DisableProjectInsightsResponse | PlainMessage<DisableProjectInsightsResponse> | undefined): boolean {
    return proto3.util.equals(DisableProjectInsightsResponse, a, b);
  }
}

/**
 * GetProjectInsightsStatusRequest checks whether insights is enabled for a project.
 *
 * @generated from message gitpod.v1.GetProjectInsightsStatusRequest
 */
export class GetProjectInsightsStatusRequest extends Message<GetProjectInsightsStatusRequest> {
  /**
   * Project to check.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  constructor(data?: PartialMessage<GetProjectInsightsStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetProjectInsightsStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectInsightsStatusRequest {
    return new GetProjectInsightsStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectInsightsStatusRequest {
    return new GetProjectInsightsStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectInsightsStatusRequest {
    return new GetProjectInsightsStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectInsightsStatusRequest | PlainMessage<GetProjectInsightsStatusRequest> | undefined, b: GetProjectInsightsStatusRequest | PlainMessage<GetProjectInsightsStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetProjectInsightsStatusRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetProjectInsightsStatusResponse
 */
export class GetProjectInsightsStatusResponse extends Message<GetProjectInsightsStatusResponse> {
  /**
   * Whether co-author insights is enabled for the project.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled = false;

  /**
   * When the insights workflow last completed successfully.
   * Nil when enabled is true but no data has been collected yet (pending state).
   *
   * @generated from field: google.protobuf.Timestamp last_ran_at = 2;
   */
  lastRanAt?: Timestamp;

  constructor(data?: PartialMessage<GetProjectInsightsStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetProjectInsightsStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "last_ran_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectInsightsStatusResponse {
    return new GetProjectInsightsStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectInsightsStatusResponse {
    return new GetProjectInsightsStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectInsightsStatusResponse {
    return new GetProjectInsightsStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectInsightsStatusResponse | PlainMessage<GetProjectInsightsStatusResponse> | undefined, b: GetProjectInsightsStatusResponse | PlainMessage<GetProjectInsightsStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetProjectInsightsStatusResponse, a, b);
  }
}

/**
 * ReportAgentTraceRequest pushes an agent trace session containing one or more
 * trace lines (typically JSONL) for storage.
 *
 * @generated from message gitpod.v1.ReportAgentTraceRequest
 */
export class ReportAgentTraceRequest extends Message<ReportAgentTraceRequest> {
  /**
   * Project the trace belongs to.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Environment that produced the trace.
   *
   * @generated from field: string environment_id = 2;
   */
  environmentId = "";

  /**
   * Agent execution that produced the trace.
   *
   * @generated from field: string agent_execution_id = 3;
   */
  agentExecutionId = "";

  /**
   * Total lines added across all edits in the trace session.
   *
   * @generated from field: int64 lines_added = 4;
   */
  linesAdded = protoInt64.zero;

  /**
   * Total lines removed across all edits in the trace session.
   *
   * @generated from field: int64 lines_removed = 5;
   */
  linesRemoved = protoInt64.zero;

  /**
   * The LLM model used during this agent session.
   *
   * @generated from field: gitpod.v1.SupportedModel model = 7;
   */
  model = SupportedModel.UNSPECIFIED;

  /**
   * Individual trace lines (typically one JSON object per line).
   * May be empty when only line-count aggregates are reported.
   * Each line is capped at 5 MiB.
   *
   * @generated from field: repeated string traces = 6;
   */
  traces: string[] = [];

  constructor(data?: PartialMessage<ReportAgentTraceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportAgentTraceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "model", kind: "enum", T: proto3.getEnumType(SupportedModel) },
    { no: 6, name: "traces", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportAgentTraceRequest {
    return new ReportAgentTraceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportAgentTraceRequest {
    return new ReportAgentTraceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportAgentTraceRequest {
    return new ReportAgentTraceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReportAgentTraceRequest | PlainMessage<ReportAgentTraceRequest> | undefined, b: ReportAgentTraceRequest | PlainMessage<ReportAgentTraceRequest> | undefined): boolean {
    return proto3.util.equals(ReportAgentTraceRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ReportAgentTraceResponse
 */
export class ReportAgentTraceResponse extends Message<ReportAgentTraceResponse> {
  constructor(data?: PartialMessage<ReportAgentTraceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportAgentTraceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportAgentTraceResponse {
    return new ReportAgentTraceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportAgentTraceResponse {
    return new ReportAgentTraceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportAgentTraceResponse {
    return new ReportAgentTraceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReportAgentTraceResponse | PlainMessage<ReportAgentTraceResponse> | undefined, b: ReportAgentTraceResponse | PlainMessage<ReportAgentTraceResponse> | undefined): boolean {
    return proto3.util.equals(ReportAgentTraceResponse, a, b);
  }
}

/**
 * GetAgentTraceStatsRequest is used by the dashboard to read aggregated agent trace stats.
 * When project_id is set, returns stats for that project only.
 * When project_id is empty, aggregates across all projects in the org.
 *
 * @generated from message gitpod.v1.GetAgentTraceStatsRequest
 */
export class GetAgentTraceStatsRequest extends Message<GetAgentTraceStatsRequest> {
  /**
   * Optional. When set, scopes stats to this project only.
   * When empty, aggregates across all projects in the org.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Date range to query within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * Time resolution for the time series. Defaults to WEEKLY if unspecified.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution = Resolution.UNSPECIFIED;

  /**
   * Organization to query stats for.
   *
   * @generated from field: string organization_id = 4;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetAgentTraceStatsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAgentTraceStatsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "resolution", kind: "enum", T: proto3.getEnumType(Resolution) },
    { no: 4, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentTraceStatsRequest {
    return new GetAgentTraceStatsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentTraceStatsRequest {
    return new GetAgentTraceStatsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentTraceStatsRequest {
    return new GetAgentTraceStatsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentTraceStatsRequest | PlainMessage<GetAgentTraceStatsRequest> | undefined, b: GetAgentTraceStatsRequest | PlainMessage<GetAgentTraceStatsRequest> | undefined): boolean {
    return proto3.util.equals(GetAgentTraceStatsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAgentTraceStatsResponse
 */
export class GetAgentTraceStatsResponse extends Message<GetAgentTraceStatsResponse> {
  /**
   * Summary totals for the requested date range.
   *
   * @generated from field: gitpod.v1.AgentTraceSummary summary = 1;
   */
  summary?: AgentTraceSummary;

  /**
   * Time series of agent trace stats, bucketed by the requested resolution.
   *
   * @generated from field: repeated gitpod.v1.AgentTraceTimeBucket time_series = 2;
   */
  timeSeries: AgentTraceTimeBucket[] = [];

  constructor(data?: PartialMessage<GetAgentTraceStatsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAgentTraceStatsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "summary", kind: "message", T: AgentTraceSummary },
    { no: 2, name: "time_series", kind: "message", T: AgentTraceTimeBucket, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentTraceStatsResponse {
    return new GetAgentTraceStatsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentTraceStatsResponse {
    return new GetAgentTraceStatsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentTraceStatsResponse {
    return new GetAgentTraceStatsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentTraceStatsResponse | PlainMessage<GetAgentTraceStatsResponse> | undefined, b: GetAgentTraceStatsResponse | PlainMessage<GetAgentTraceStatsResponse> | undefined): boolean {
    return proto3.util.equals(GetAgentTraceStatsResponse, a, b);
  }
}

/**
 * AgentTraceSummary contains aggregate totals for a date range.
 *
 * @generated from message gitpod.v1.AgentTraceSummary
 */
export class AgentTraceSummary extends Message<AgentTraceSummary> {
  /**
   * Total number of agent trace sessions in the date range.
   *
   * @generated from field: int64 total_sessions = 1;
   */
  totalSessions = protoInt64.zero;

  /**
   * Total lines added across all sessions.
   *
   * @generated from field: int64 total_lines_added = 2;
   */
  totalLinesAdded = protoInt64.zero;

  /**
   * Total lines removed across all sessions.
   *
   * @generated from field: int64 total_lines_removed = 3;
   */
  totalLinesRemoved = protoInt64.zero;

  /**
   * Per-model breakdown of session stats.
   *
   * @generated from field: repeated gitpod.v1.AgentTraceModelBreakdown by_model = 4;
   */
  byModel: AgentTraceModelBreakdown[] = [];

  /**
   * Fractional change in total_sessions compared to the previous period of
   * equal length. Computed as (current - previous) / previous. Zero when there
   * is no previous data.
   *
   * @generated from field: double total_sessions_trend = 5;
   */
  totalSessionsTrend = 0;

  /**
   * Fractional change in total_lines_added compared to the previous period.
   *
   * @generated from field: double total_lines_added_trend = 6;
   */
  totalLinesAddedTrend = 0;

  /**
   * Fractional change in total_lines_removed compared to the previous period.
   *
   * @generated from field: double total_lines_removed_trend = 7;
   */
  totalLinesRemovedTrend = 0;

  constructor(data?: PartialMessage<AgentTraceSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentTraceSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_sessions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "total_lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "total_lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "by_model", kind: "message", T: AgentTraceModelBreakdown, repeated: true },
    { no: 5, name: "total_sessions_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "total_lines_added_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "total_lines_removed_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentTraceSummary {
    return new AgentTraceSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentTraceSummary {
    return new AgentTraceSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentTraceSummary {
    return new AgentTraceSummary().fromJsonString(jsonString, options);
  }

  static equals(a: AgentTraceSummary | PlainMessage<AgentTraceSummary> | undefined, b: AgentTraceSummary | PlainMessage<AgentTraceSummary> | undefined): boolean {
    return proto3.util.equals(AgentTraceSummary, a, b);
  }
}

/**
 * AgentTraceModelBreakdown contains stats for a single LLM model.
 *
 * @generated from message gitpod.v1.AgentTraceModelBreakdown
 */
export class AgentTraceModelBreakdown extends Message<AgentTraceModelBreakdown> {
  /**
   * The model these stats are for.
   *
   * @generated from field: gitpod.v1.SupportedModel model = 1;
   */
  model = SupportedModel.UNSPECIFIED;

  /**
   * Number of sessions that used this model.
   *
   * @generated from field: int64 sessions = 2;
   */
  sessions = protoInt64.zero;

  /**
   * Lines added by sessions using this model.
   *
   * @generated from field: int64 lines_added = 3;
   */
  linesAdded = protoInt64.zero;

  /**
   * Lines removed by sessions using this model.
   *
   * @generated from field: int64 lines_removed = 4;
   */
  linesRemoved = protoInt64.zero;

  constructor(data?: PartialMessage<AgentTraceModelBreakdown>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentTraceModelBreakdown";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "model", kind: "enum", T: proto3.getEnumType(SupportedModel) },
    { no: 2, name: "sessions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentTraceModelBreakdown {
    return new AgentTraceModelBreakdown().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentTraceModelBreakdown {
    return new AgentTraceModelBreakdown().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentTraceModelBreakdown {
    return new AgentTraceModelBreakdown().fromJsonString(jsonString, options);
  }

  static equals(a: AgentTraceModelBreakdown | PlainMessage<AgentTraceModelBreakdown> | undefined, b: AgentTraceModelBreakdown | PlainMessage<AgentTraceModelBreakdown> | undefined): boolean {
    return proto3.util.equals(AgentTraceModelBreakdown, a, b);
  }
}

/**
 * AgentTraceTimeBucket contains stats for a single time period.
 *
 * @generated from message gitpod.v1.AgentTraceTimeBucket
 */
export class AgentTraceTimeBucket extends Message<AgentTraceTimeBucket> {
  /**
   * Start of this time bucket.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * Number of agent trace sessions in this bucket.
   *
   * @generated from field: int64 total_sessions = 2;
   */
  totalSessions = protoInt64.zero;

  /**
   * Total lines added in this bucket.
   *
   * @generated from field: int64 total_lines_added = 3;
   */
  totalLinesAdded = protoInt64.zero;

  /**
   * Total lines removed in this bucket.
   *
   * @generated from field: int64 total_lines_removed = 4;
   */
  totalLinesRemoved = protoInt64.zero;

  /**
   * Per-model breakdown for this bucket.
   *
   * @generated from field: repeated gitpod.v1.AgentTraceModelBreakdown by_model = 5;
   */
  byModel: AgentTraceModelBreakdown[] = [];

  constructor(data?: PartialMessage<AgentTraceTimeBucket>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentTraceTimeBucket";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "total_sessions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "total_lines_added", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "total_lines_removed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "by_model", kind: "message", T: AgentTraceModelBreakdown, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentTraceTimeBucket {
    return new AgentTraceTimeBucket().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentTraceTimeBucket {
    return new AgentTraceTimeBucket().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentTraceTimeBucket {
    return new AgentTraceTimeBucket().fromJsonString(jsonString, options);
  }

  static equals(a: AgentTraceTimeBucket | PlainMessage<AgentTraceTimeBucket> | undefined, b: AgentTraceTimeBucket | PlainMessage<AgentTraceTimeBucket> | undefined): boolean {
    return proto3.util.equals(AgentTraceTimeBucket, a, b);
  }
}

/**
 * PullRequestStat represents speed metrics for a single merged pull request.
 *
 * @generated from message gitpod.v1.PullRequestStat
 */
export class PullRequestStat extends Message<PullRequestStat> {
  /**
   * PR/MR number from the SCM provider. Together with project_id forms the
   * idempotency key for upserts.
   *
   * @generated from field: int32 pr_number = 1;
   */
  prNumber = 0;

  /**
   * Raw SCM username of the PR author (e.g. GitHub user.login, GitLab author.username).
   *
   * @generated from field: string author_login = 2;
   */
  authorLogin = "";

  /**
   * When the PR was opened.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * When the PR was merged.
   *
   * @generated from field: google.protobuf.Timestamp merged_at = 4;
   */
  mergedAt?: Timestamp;

  /**
   * Author date of the earliest commit on the PR branch.
   *
   * @generated from field: google.protobuf.Timestamp first_commit_at = 5;
   */
  firstCommitAt?: Timestamp;

  /**
   * Timestamp of the earliest approving review. Unset when the PR had no approvals.
   *
   * @generated from field: google.protobuf.Timestamp first_approval_at = 6;
   */
  firstApprovalAt?: Timestamp;

  /**
   * Branch the PR was merged into (e.g. "main").
   *
   * @generated from field: string target_branch = 7;
   */
  targetBranch = "";

  /**
   * SCM platform the PR was fetched from.
   *
   * @generated from field: gitpod.v1.ScmProvider scm_provider = 8;
   */
  scmProvider = ScmProvider.UNSPECIFIED;

  constructor(data?: PartialMessage<PullRequestStat>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PullRequestStat";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pr_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "author_login", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "merged_at", kind: "message", T: Timestamp },
    { no: 5, name: "first_commit_at", kind: "message", T: Timestamp },
    { no: 6, name: "first_approval_at", kind: "message", T: Timestamp },
    { no: 7, name: "target_branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "scm_provider", kind: "enum", T: proto3.getEnumType(ScmProvider) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PullRequestStat {
    return new PullRequestStat().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PullRequestStat {
    return new PullRequestStat().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PullRequestStat {
    return new PullRequestStat().fromJsonString(jsonString, options);
  }

  static equals(a: PullRequestStat | PlainMessage<PullRequestStat> | undefined, b: PullRequestStat | PlainMessage<PullRequestStat> | undefined): boolean {
    return proto3.util.equals(PullRequestStat, a, b);
  }
}

/**
 * ReportPrStatsRequest is sent by the CLI to push PR speed metrics.
 *
 * @generated from message gitpod.v1.ReportPrStatsRequest
 */
export class ReportPrStatsRequest extends Message<ReportPrStatsRequest> {
  /**
   * Project that was analyzed.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Per-PR stats to upsert.
   *
   * @generated from field: repeated gitpod.v1.PullRequestStat stats = 2;
   */
  stats: PullRequestStat[] = [];

  constructor(data?: PartialMessage<ReportPrStatsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportPrStatsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stats", kind: "message", T: PullRequestStat, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportPrStatsRequest {
    return new ReportPrStatsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportPrStatsRequest {
    return new ReportPrStatsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportPrStatsRequest {
    return new ReportPrStatsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReportPrStatsRequest | PlainMessage<ReportPrStatsRequest> | undefined, b: ReportPrStatsRequest | PlainMessage<ReportPrStatsRequest> | undefined): boolean {
    return proto3.util.equals(ReportPrStatsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ReportPrStatsResponse
 */
export class ReportPrStatsResponse extends Message<ReportPrStatsResponse> {
  /**
   * Number of rows inserted (new PRs).
   *
   * @generated from field: int64 inserted_count = 1;
   */
  insertedCount = protoInt64.zero;

  /**
   * Number of rows updated (re-reported PRs).
   *
   * @generated from field: int64 updated_count = 2;
   */
  updatedCount = protoInt64.zero;

  constructor(data?: PartialMessage<ReportPrStatsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportPrStatsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inserted_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "updated_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportPrStatsResponse {
    return new ReportPrStatsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportPrStatsResponse {
    return new ReportPrStatsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportPrStatsResponse {
    return new ReportPrStatsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReportPrStatsResponse | PlainMessage<ReportPrStatsResponse> | undefined, b: ReportPrStatsResponse | PlainMessage<ReportPrStatsResponse> | undefined): boolean {
    return proto3.util.equals(ReportPrStatsResponse, a, b);
  }
}

/**
 * GetPrStatsSummaryRequest is used by the dashboard to read aggregated PR speed metrics.
 *
 * @generated from message gitpod.v1.GetPrStatsSummaryRequest
 */
export class GetPrStatsSummaryRequest extends Message<GetPrStatsSummaryRequest> {
  /**
   * Project to query stats for.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Date range to query within. PRs are filtered by merged_at.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  constructor(data?: PartialMessage<GetPrStatsSummaryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetPrStatsSummaryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPrStatsSummaryRequest {
    return new GetPrStatsSummaryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPrStatsSummaryRequest {
    return new GetPrStatsSummaryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPrStatsSummaryRequest {
    return new GetPrStatsSummaryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPrStatsSummaryRequest | PlainMessage<GetPrStatsSummaryRequest> | undefined, b: GetPrStatsSummaryRequest | PlainMessage<GetPrStatsSummaryRequest> | undefined): boolean {
    return proto3.util.equals(GetPrStatsSummaryRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetPrStatsSummaryResponse
 */
export class GetPrStatsSummaryResponse extends Message<GetPrStatsSummaryResponse> {
  /**
   * Median lead time for changes in seconds (first commit → merge).
   *
   * @generated from field: double lead_time_seconds = 1;
   */
  leadTimeSeconds = 0;

  /**
   * Trend of lead time compared to the previous period of equal length (%).
   * Calculated as (current - previous) / previous.
   *
   * @generated from field: double lead_time_trend = 2;
   */
  leadTimeTrend = 0;

  /**
   * Total number of PRs merged in the date range.
   *
   * @generated from field: int64 prs_merged_count = 3;
   */
  prsMergedCount = protoInt64.zero;

  /**
   * Trend of PRs merged compared to the previous period (%).
   *
   * @generated from field: double prs_merged_trend = 4;
   */
  prsMergedTrend = 0;

  /**
   * Median time to first approval in seconds (PR opened → first approving review).
   * Zero when no PRs in the range had approvals.
   *
   * @generated from field: double time_to_first_approval_seconds = 5;
   */
  timeToFirstApprovalSeconds = 0;

  /**
   * Trend of time to first approval compared to the previous period (%).
   *
   * @generated from field: double time_to_first_approval_trend = 6;
   */
  timeToFirstApprovalTrend = 0;

  /**
   * Deployment frequency: PRs merged to the default branch per week.
   *
   * @generated from field: double deployment_frequency = 7;
   */
  deploymentFrequency = 0;

  /**
   * Trend of deployment frequency compared to the previous period (%).
   *
   * @generated from field: double deployment_frequency_trend = 8;
   */
  deploymentFrequencyTrend = 0;

  /**
   * Sparkline data for the card's trend line (typically ~4 weekly points).
   * Values represent PRs merged per bucket.
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint sparkline = 9;
   */
  sparkline: TimeSeriesPoint[] = [];

  constructor(data?: PartialMessage<GetPrStatsSummaryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetPrStatsSummaryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lead_time_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lead_time_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "prs_merged_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "prs_merged_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "time_to_first_approval_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "time_to_first_approval_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "deployment_frequency", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "deployment_frequency_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "sparkline", kind: "message", T: TimeSeriesPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPrStatsSummaryResponse {
    return new GetPrStatsSummaryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPrStatsSummaryResponse {
    return new GetPrStatsSummaryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPrStatsSummaryResponse {
    return new GetPrStatsSummaryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPrStatsSummaryResponse | PlainMessage<GetPrStatsSummaryResponse> | undefined, b: GetPrStatsSummaryResponse | PlainMessage<GetPrStatsSummaryResponse> | undefined): boolean {
    return proto3.util.equals(GetPrStatsSummaryResponse, a, b);
  }
}

/**
 * GetInsightsSummaryRequest returns project-level insights adoption for the org.
 *
 * @generated from message gitpod.v1.GetInsightsSummaryRequest
 */
export class GetInsightsSummaryRequest extends Message<GetInsightsSummaryRequest> {
  /**
   * Organization to query.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetInsightsSummaryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetInsightsSummaryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetInsightsSummaryRequest {
    return new GetInsightsSummaryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetInsightsSummaryRequest {
    return new GetInsightsSummaryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetInsightsSummaryRequest {
    return new GetInsightsSummaryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetInsightsSummaryRequest | PlainMessage<GetInsightsSummaryRequest> | undefined, b: GetInsightsSummaryRequest | PlainMessage<GetInsightsSummaryRequest> | undefined): boolean {
    return proto3.util.equals(GetInsightsSummaryRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetInsightsSummaryResponse
 */
export class GetInsightsSummaryResponse extends Message<GetInsightsSummaryResponse> {
  /**
   * Number of projects with insights enabled.
   *
   * @generated from field: int64 enabled_project_count = 1;
   */
  enabledProjectCount = protoInt64.zero;

  /**
   * Total number of projects in the organization.
   *
   * @generated from field: int64 total_project_count = 2;
   */
  totalProjectCount = protoInt64.zero;

  constructor(data?: PartialMessage<GetInsightsSummaryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetInsightsSummaryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled_project_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "total_project_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetInsightsSummaryResponse {
    return new GetInsightsSummaryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetInsightsSummaryResponse {
    return new GetInsightsSummaryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetInsightsSummaryResponse {
    return new GetInsightsSummaryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetInsightsSummaryResponse | PlainMessage<GetInsightsSummaryResponse> | undefined, b: GetInsightsSummaryResponse | PlainMessage<GetInsightsSummaryResponse> | undefined): boolean {
    return proto3.util.equals(GetInsightsSummaryResponse, a, b);
  }
}

